var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape16 = function SvgShape16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 92,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.197 13.145C51.517 7.1 55.677 4.079 60.11 2.577a30.82 30.82 0 0 1 19.777 0c4.434 1.502 8.595 4.524 16.915 10.568l18.71 13.59c4.941 3.589 7.411 5.383 9.425 7.538a30.8 30.8 0 0 1 6.557 10.817c.978 2.781 1.426 5.801 2.322 11.841l3.464 23.359c1.571 10.596 2.357 15.894 1.564 20.669a30.8 30.8 0 0 1-9.829 17.892c-3.605 3.231-8.499 5.41-18.286 9.769l-22.173 9.877c-5.906 2.63-8.86 3.945-11.895 4.618a30.8 30.8 0 0 1-13.324 0c-3.036-.673-5.99-1.988-11.895-4.618l-22.174-9.877c-9.787-4.359-14.68-6.538-18.286-9.769a30.8 30.8 0 0 1-9.828-17.892C.36 96.184 1.147 90.886 2.719 80.29l3.464-23.359c.895-6.04 1.343-9.06 2.321-11.841a30.8 30.8 0 0 1 6.557-10.817c2.014-2.155 4.485-3.95 9.426-7.538z",
    opacity: 0.1
  })));
};
export default SvgShape16;